import { all, call, put, takeLatest } from 'redux-saga/effects';
import { PATCH_OPERATIONS } from '../../api';
import * as localizationApi from '../../api/localizationApi';
import { errorHelper, responseValidateStatusOrThrow } from '../helpers';
import { LOCALE_PATH } from './helpers';
import { types } from './index';

export function* setLandingPageLanguage({ lang, loggedIn }) {
  try {
    let response;
    if (loggedIn) {
      response = yield call(localizationApi.setCurrentUserLang, [
        { op: PATCH_OPERATIONS.REPLACE, path: LOCALE_PATH, value: lang },
      ]);
      yield responseValidateStatusOrThrow(response);
      yield put({ payload: response.data?.locale, type: types.SET_LANDING_PAGE_LANGUAGE_SUCCESS });
    } else {
      yield put({ payload: lang, type: types.SET_LANDING_PAGE_LANGUAGE_SUCCESS });
    }
  } catch (error) {
    yield put(errorHelper(types.SET_LANDING_PAGE_LANGUAGE_FAILURE, error));
  }
}

export function* setUserModalLanguage({ lang }) {
  try {
    const response = yield call(localizationApi.setCurrentUserLang, [
      { op: PATCH_OPERATIONS.REPLACE, path: LOCALE_PATH, value: lang },
    ]);
    yield responseValidateStatusOrThrow(response);
    yield put({ payload: response.data?.locale, type: types.SET_USER_MODAL_LANGUAGE_SUCCESS });
  } catch (error) {
    yield put(errorHelper(types.SET_USER_MODAL_LANGUAGE_FAILURE, error));
  }
}

export default function* localizationSagas() {
  yield all([
    takeLatest(types.SET_LANDING_PAGE_LANGUAGE_REQUEST, setLandingPageLanguage),
    takeLatest(types.SET_USER_MODAL_LANGUAGE_REQUEST, setUserModalLanguage),
  ]);
}
